import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col lg:flex-row items-center justify-center bg-black/[.67]" }
const _hoisted_2 = {
  key: 0,
  class: "w-full lg:w-96 min-h-[360px] lg:min-h-full h-[60vh] lg:h-full shrink-0"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "w-full lg:hidden text-h5 text-mono-white bg-mono-ns-300 py-5 text-center my-auto font-bold relative"
}

import {onMounted, onUnmounted, ref, watch} from "vue";
import {useStore} from "../store";
import {loadScript} from "../../../shared/load-script";
// eslint-disable-next-line no-undef
import {useContentStore} from "../store/content";
import {ContentStream} from "../services/content";
import LanguageSelector from "./LanguageSelector.vue";
// import VideoAnalytics from "../../../lib/conviva/index.js"
import PlaybackReportService from "../services/reporting";
import config from "../config";
import IconArrowLeft from "./IconArrowLeft.vue";
import getCast from "../../../lib/chromecast/index";
import CastControls from "./CastControls.vue";
import * as Sentry from "@sentry/vue";

import JWPlayer = jwplayer.JWPlayer;
interface Callback {
    // eslint-disable-next-line
    (): any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PlayerComponent',
  setup(__props) {

const store = useStore();
const contentItem = useContentStore()
let VideoAnalytics: "VideoAnalytics" | null | undefined = null;

const modal = ref(false);
const screen = ref(null);
const showCastControls = ref(false);
const chatArrowVisible = ref(false);
const cinemaMode = ref(false);
let chatArrowTimeout = 0;
let castAttempt = false;

function toggleLangSwitcher(){
    modal.value = !modal.value;
    store.toggleBackdrop()
}

function toggleCinemaMode(){
    if (!playerLoader)
        return
    cinemaMode.value = !cinemaMode.value;
    store.toggleBackdrop()
    playerLoader.player?.removeButton("cinema-mode-btn")
    if (cinemaMode.value){
        playerLoader.player?.addButton(
            '<svg class="jw-svg-icon" xmlns="http://www.w3.org/2000/svg"><use href="#icon-dm"/></svg>',
            "Default Mode",
            toggleCinemaMode,
            "cinema-mode-btn",
            "cinema-mode-btn",
        )
    }else{
        playerLoader.player?.addButton(
            '<svg class="jw-svg-icon" xmlns="http://www.w3.org/2000/svg"><use href="#icon-cm"/></svg>',
            "Cinema Mode",
            toggleCinemaMode,
            "cinema-mode-btn",
            "cinema-mode-btn",
        )
    }
}

let playerLoader: VideoPlayerLoader | null = null;

class VideoPlayerLoader {
    private videoIdInt: number;
    private videoId: string;
    private onSetupCallback: null | Callback;
    public player: JWPlayer | null;
    private reported = false;
    private analytics: "VideoAnalytics" | null | undefined;
    private reporting: PlaybackReportService | null = null;

    constructor(onSetupCallback: null | Callback = null) {
        this.videoId = contentItem.itemId.toString();
        this.videoIdInt = contentItem.id.valueOf();
        this.player = null;

        this.initialize()
        this.onSetupCallback = onSetupCallback;

    }

    initialize(){
        this.create(store.startingPosition)
    }

    recordProgress (position: number){
        const key = "fite.pbp";
        const rawRecord = localStorage.getItem(key);
        if (!rawRecord)
            return null;
        const record = JSON.parse(rawRecord);
        if (!record){
            return null;
        }
        let updated = false;
        for (let i = 0; i < record.data.length; i++){
            if (record.data[i].video_id === this.videoIdInt){
                record.data[i].position = position;
                record.data[i].created_at = new Date().toISOString();
                updated = true;
                break
            }
        }
        if (!updated){
            record.data.push({
                "video_id": this.videoIdInt,
                "created_at": new Date().toISOString(),
                "position": position
            })
        }
        try {
            localStorage.setItem(key, JSON.stringify(record));
        }catch (e){
            console.log(e)
        }
        return null;
    }

    _beforeunload(){
        if (!this.player)
            return
        if (this.player.getState() !== "completed" && Math.round(this.player.getCurrentTime()) > 0){
            this.reportProgress(Math.round(this.player.getCurrentTime()));
        }
    }
    attachEvents() {
        window.addEventListener("beforeunload", this._beforeunload.bind(this))
        if (!this.player)
            return
        // this.player.on("resize", function (data){
        //     console.log(data);
        // })
        // if (this.player){
        //     this.player.on("pause", (event) => {
        //         if (this.player){
        //             this.recordProgress(Math.round(this.player.getCurrentTime()))
        //         }
        //     })
        // }
    }

    reportProgress(position: number){
        if (this.reported)
            return;
        this.reported = true;
        const
            url = new URL(new URL(window.location.href).origin + "/api/_v2/users/me/playbacks/"),
            payload: {[key: string]: string} = {
                "video_id": this.videoIdInt.toString(),
                "position": position.toString()
            };
        Object.keys(payload).forEach(key => url.searchParams.append(key, payload[key]))
        this.recordProgress(position);
        try{
            fetch(url.toString(), {
                method: "put",
                keepalive: true,
                credentials: 'include',
            }).then().catch()
        }catch (e){
            console.log(e)
        }
    }

    initAnalytics(streamData: ContentStream){
        if (!VideoAnalytics){
            return null;
        }
        const meta = {
            site: "fite",
            brand: (contentItem.brands.filter(row => row.is_primary).pop())?.name,
            genre: (contentItem.genres.filter(row => row.is_primary).pop())?.name,
            genreList: contentItem.genres.map((row) => row.name).join(","),
            cdn: "",
            policy: streamData.cdn.policy,
            linear: contentItem.video_types.includes("linear"),
            isPaid: contentItem.billing && contentItem.billing.is_chargeable,
            sid: streamData.sid,
            isTrailer: false,
            preview: false
        }

        const analytics = new VideoAnalytics(
            contentItem.itemId,
            contentItem.tags.includes("on_air") ? 'live' : 'vod',
            true,
            config.JW_VERSION,
            streamData.advid,
            contentItem.tags.includes("dev"),
            meta
        )
        analytics.loadPlayer(this.player)
        return analytics
    }

    initTracking(){
        if (!this.player) return null;

        const reporting = new PlaybackReportService(
            contentItem.itemId,
            contentItem.reportChannelId,
            "player",
            60
        )
        reporting.attachPlayer(this.player as JWPlayer)
        return reporting
    }

    create(startTime: number){
        if (contentItem.contentStream){
            this.load(contentItem.contentStream, startTime);
            return
        }
        const qs = {
            site: "fite",
            ref: "other",
            ts: new Date().getTime().toString()
        }
        const settingsUrl = `/embed/settings/${this.videoId}/?${new URLSearchParams(qs).toString()}`;

        fetch(settingsUrl, {
            method: "GET",
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            redirect: 'manual',
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(result => {
                if (result.status !== 200){
                    return Promise.reject(result)
                }
                return result.json()
            })
            .then(response => {
                this.load(response, startTime)
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadPlayer(streamData: ContentStream, startTime: number){
        window.jwplayer.key = config.JW_KEY;
        this.player = window.jwplayer('player-block') as JWPlayer
        if (!this.player)
            return;
        // eslint-disable-next-line
        const jwparams : any = {
            base: `/static/jwplayer-${config.JW_VERSION}/`,
            liveTimeout: 0,
            aspecratio: '16:9',
            width: '100%',
            height: '100%',
            autostart: true,
            stretching: "uniform",
            skin: {
                name: "seven",
                active: "red",
                inactive: "white",
                background: "black"
            },
            playlist: [],
        };

        if (contentItem.logo){
            jwparams.logo = contentItem.logo
        }

        if (streamData.advertising && !contentItem.video_types.includes("linear")){
            jwparams.advertising = {
                client: streamData.advertising.client,
                schedule: streamData.advertising.schedule,
            }
        }

        const item = {
            sources: [{
                file: streamData.url,
            }],
            title: contentItem.reportTitle,
            withCredentials: true,
            image: ""
        };

        if (contentItem.links?.image && !contentItem.links?.image.templated){
            item.image = contentItem.links?.image.href
        }

        if (startTime >= 0){
            item.starttime = startTime;
        }

        jwparams.playlist.push(item);

        this.player.setup(jwparams);

        this.analytics = this.initAnalytics(streamData);

        this.reporting = this.initTracking()

        this.chromecast()

        if (this.onSetupCallback){
            setTimeout(this.onSetupCallback, 1000)
            //this.onSetupCallback()
        }
        if (!window.players){
            window.players = {}
        }
        window.players.main = this.player;
        this.attachEvents()
        if (contentItem.languages.length > 1){
            this.addLanguageSwitcherBtn()
        }
        this.player?.addButton(
            '<svg class="jw-svg-icon" xmlns="http://www.w3.org/2000/svg"><use href="#icon-cm"/></svg>',
            "Cinema Mode",
            toggleCinemaMode,
            "cinema-mode-btn",
            "cinema-mode-btn",
        )
    }

    load(streamData: ContentStream, startTime: number) {
        import(
            /* webpackChunkName: "trl-cv" */
            /* webpackFetchPriority: "high" */
            '../../../lib/conviva/index.js').then((module) => {
            VideoAnalytics = module.default;
            loadScript(`/static/jwplayer-${config.JW_VERSION}/jwplayer.js`)
                .then((result) => {
                    if (!result)
                        return;

                    this.loadPlayer(streamData, startTime)
                })
        })
            .catch((e) => {
                Sentry.captureMessage(`${e.name}: ${e.message}`, "error");
                loadScript(`/static/jwplayer-${config.JW_VERSION}/jwplayer.js`)
                    .then((result) => {
                        if (!result)
                            return;

                        this.loadPlayer(streamData, startTime)
                    })
            });

    }

    addLanguageSwitcherBtn(){
        this.player?.addButton(
            '<svg class="jw-svg-icon" xmlns="http://www.w3.org/2000/svg"><use href="#icon-ls"/></svg>',
            "Languages",
            toggleLangSwitcher,
            "language-switcher-btn",
            "language-switcher-btn",
        )
    }

    updateStream(id: string, videoId: number, streamData: ContentStream){
        if (!this.player)
            return
        if (this.analytics){
            this.analytics.reportPlaybackEnded()
            this.analytics = null;
        }
        if (this.reporting){
            this.reporting.remove()
            this.reporting = null;
        }

        Math.round(this.player.getCurrentTime())
        const item = {
            sources: [{
                file: streamData.url,
            }],
            withCredentials: true,
            title: contentItem.title,
            starttime: Math.round(this.player.getCurrentTime())
        };
        this.player.load(item)
        this.analytics = this.initAnalytics(streamData);
        this.reporting = this.initTracking()
    }

    chromecast(){
        const castOpts = {}
        if (contentItem.tags.includes("dev")){
            castOpts["receiver"] = '159A62D0'
        }
        const cast = getCast(castOpts);
        this.player.on("ready", () => {
            if (cast.available){
                this.showCastButton(true)
            }
        })
        cast.on("available", (e) => {
            this.showCastButton(e?.detail?.value as boolean || false)
        })

        cast.on("disconnected", (e) => {
            contentItem.fetchStream("local")
                .then(() => {
                    this.create(e?.detail?.time || -1)
                    setTimeout(function (){
                        showCastControls.value = false
                        castAttempt = false;
                    }, 1000);
                })
        })

        cast.on("connected", (e) => {
            if (e?.detail?.active && parseInt(cast.contentId()) === contentItem.id){
                castAttempt = true;
                if (this.player){
                    this.player.stop()
                    this.player.remove()
                }
                showCastControls.value = true
            }else{
                castAttempt = true;
                contentItem.fetchStream("cast")
                    .then(() => {
                        if (!this.player)
                            return;
                        const currentTime = Math.round(this.player.getCurrentTime())
                        this.player.stop()
                        this.player.remove()

                        showCastControls.value = true
                        let customData = {}
                        if (this.analytics){
                            customData = this.analytics.getContentInfoCast(contentItem.contentStream?.url)
                            customData.urlPolicy = contentItem.contentStream?.cdn.policy;
                            customData.sessionId = contentItem.contentStream?.sid;
                        }
                        let poster = "https://www.trillertv.com/static/img/home-trillertv.png";
                        if (contentItem.links?.poster && !contentItem.links?.poster.templated){
                            poster = contentItem.links?.poster.href;
                        }else if (contentItem.links?.image && !contentItem.links?.image.templated){
                            poster = contentItem.links?.image.href;
                        }

                        cast.cast(contentItem.id.toString(), contentItem.contentStream?.url, {
                            title: contentItem.title,
                            poster: poster,
                            time: currentTime,
                            customData: {
                                conviva: customData
                            }
                        })
                    })
            }
        })
    }

    showCastButton(visible: boolean){
        const plE = document.querySelector('#player-block')
        if (!plE)
            return;

        if (visible){
            if (!plE.classList.contains('jw-flag-cast-available')){
                plE.classList.add('jw-flag-cast-available')
            }
            const castIcon = document.querySelector<HTMLSpanElement>('.jw-icon-cast')
            if (castIcon){
                castIcon.style.display = 'flex'
            }
        }else{
            plE.classList.remove('jw-flag-cast-available')
            const castIcon = document.querySelector<HTMLSpanElement>('.jw-icon-cast')
            if (castIcon){
                castIcon.style.display = 'none'
            }
        }
    }
}

onMounted(() => {
    if(screen.value)
        (screen.value as HTMLElement).dispatchEvent(new CustomEvent(
            'switch-screen',
            {
                bubbles: true,
                detail: { visible: true}
            }))
    if (store.castActive){
        showCastControls.value = true
        castAttempt = true;
        const castOpts = {}
        if (contentItem.tags.includes("dev")){
            castOpts["receiver"] = '159A62D0'
        }
        const cast = getCast(castOpts);
        const onDisconnect = (e) => {
            cast.off("disconnected", onDisconnect)
            store.updateCurrentPosition(e?.detail?.time || -1)
            showCastControls.value = false
            playerLoader = new VideoPlayerLoader()
            castAttempt = false;

        }
        cast.on("disconnected", onDisconnect)
    }else{
        playerLoader = new VideoPlayerLoader()
    }
})

onUnmounted(() => {
    if(screen.value)
        (screen.value as HTMLElement).dispatchEvent(new CustomEvent(
            'switch-screen',
            {
                bubbles: true,
                detail: { visible: false}
            }))
})

watch(() => contentItem.contentStream?.url, async (newContent) => {
    if (!newContent || castAttempt)
        return
    if (playerLoader && contentItem.contentStream){
        playerLoader.updateStream(contentItem.itemId, contentItem.id, contentItem.contentStream)
    }

})
let chatUrl = ""
if (contentItem.chatRoom){
    chatUrl = `/embed/v1/chat/${contentItem.itemId}/?pt=${encodeURIComponent(contentItem.chatRoom)}`
}

function onMouseMove(){
    if (!contentItem.chatRoom || 'ontouchstart' in window)
        return
    if (!playerLoader || !playerLoader.player){
        return
    }
    if (!chatArrowVisible.value)
        chatArrowVisible.value = true;
    clearTimeout(chatArrowTimeout)
    if (playerLoader.player.getState() === 'playing'){
        chatArrowTimeout = setTimeout(() => {
            chatArrowVisible.value = false
        }, 2000)
    }

}
function onTouchStart(){
    if (!contentItem.chatRoom)
        return
    if (!playerLoader || !playerLoader.player || playerLoader.player.getState() !== 'playing'){
        return
    }
    chatArrowVisible.value = true;
    clearTimeout(chatArrowTimeout)
    chatArrowTimeout = setTimeout(() => {
        chatArrowVisible.value = false
    }, 4000)
}

function onOpenChat(){
    store.toggleChat()
}
// fixed inset-0 z-[999]
// - h-full w-full

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pt-2.5 md:pt-20 flex",
    ref_key: "screen",
    ref: screen
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["", {
                    'fixed inset-0 z-[999] ': cinemaMode.value,
                    'flex justify-center w-full h-full aspect-video player-wrapper lg:min-h-[360px]': !cinemaMode.value,
                    'xl:w-10/12': !_unref(store).chatOpened && !cinemaMode.value
                }]),
        onMousemove: onMouseMove,
        onTouchstart: onTouchStart
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["h-full relative", {'w-full': cinemaMode.value, 'aspect-video': !cinemaMode.value}])
        }, [
          (showCastControls.value)
            ? (_openBlock(), _createBlock(CastControls, { key: 0 }))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createElementVNode("div", { id: "player-block" }, null, -1)),
          (_unref(chatUrl) && !_unref(store).chatOpened)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["absolute top-1 right-4 p-3 hidden flex-row justify-center gap-2 group", {'lg:flex': chatArrowVisible.value}]),
                onClick: onOpenChat
              }, [
                _createVNode(IconArrowLeft, { rotate: false }),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "group-hover:opacity-100 transition-opacity bg-mono-ns-200 px-6 py-1 text-p6 rounded-lg absolute right-0 translate-y-10 opacity-0 mx-auto whitespace-nowrap" }, [
                  _createTextVNode(" Live Chat "),
                  _createElementVNode("span", { class: "absolute -top-1 right-4 -z-10 h-3 w-3 rotate-45 bg-mono-ns-200" })
                ], -1))
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ], 34),
      (_unref(chatUrl) && _unref(store).chatOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("iframe", {
              class: "w-full h-full",
              src: _unref(chatUrl)
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      (_unref(chatUrl) && !_unref(store).chatOpened && _unref(playerLoader))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "absolute inset-y-0 left-0 p-3",
              onClick: onOpenChat
            }, [
              _createVNode(IconArrowLeft, {
                rotate: true,
                vertical: true
              })
            ]),
            _cache[2] || (_cache[2] = _createTextVNode(" Live Chat "))
          ]))
        : _createCommentVNode("", true)
    ]),
    (modal.value)
      ? (_openBlock(), _createBlock(LanguageSelector, {
          key: 0,
          onToggle: toggleLangSwitcher
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})